/* global jQuery */

export default class Select2Dropdown {
  init() {
    [...document.querySelectorAll('.custom-select2')].forEach(element => {
      const placeholder =
        element.getAttribute('placeholder') || element.querySelector('option[value=""]').innerHTML;

      const allowClear = Boolean(element.getAttribute('data-allow-clear'));

      jQuery(element).select2({
        placeholder: jQuery.trim(placeholder),
        allowClear: allowClear,
        theme: 'default large_style',
      });
    });
  }
}
